import Constants from '@/common/constants';

import store from '@/store';

/**
 * Показывает алерт "Нет доступа" и обновляет навигацию при нажатии OK,
 * чтобы меню подгрузилось согласно актуальным правам пользователя.
 * @param {string} [message] - текст сообщения (по умолчанию — общее)
 */
export function noAccessAlert(message = 'У Вас нет доступа к просмотру объекта этого класса.') {
  Constants.alert.fire('Нет доступа', message, 'error');
  store.dispatch('menu/getMenu');
}
